

<igx-grid id="testGrid"  [data]="this.contacts" [width]="'99%'" [height]="'2000px;'" style="margin-left:10px;margin-top:10px;"
 [primaryKey]="'id'" 
[emptyGridMessage]="'Test Gride List Empty'" >

<igx-column field="view" header=" " width="50px" required ></igx-column>

<igx-column field="id" header="Contact Id*"width="90px" ></igx-column>
<igx-column field="name" header="Name" width="90px"></igx-column>

<ng-template igxGridDetail let-dataItem style="margin-top:20px;height:300px;width:1000px;" >
    <igx-tabs  [selectedIndex]="0" style="width:100%;">
        <igx-tab-item>
            <igx-tab-header>
                <span class="ace-heading-text-grid-tabs">Grid Detail Form</span>
            </igx-tab-header>
            <igx-tab-content style="height:600px;margin-bottom:10px;margin-top:10px;width:100%">
               <app-form-grid-test></app-form-grid-test>
            </igx-tab-content>
        </igx-tab-item>
       
    </igx-tabs>
</ng-template>

</igx-grid>








